/**
 * 算法模型共享界面
 */

import React, { Component } from 'react'
import { connect } from 'react-redux';
import axios from 'axios'
import moment from 'moment'
import './index.css'
import { Radio, Checkbox, Pagination, Input, DatePicker, Select, Cascader, message } from 'antd';
import {
  algProduceCategoryOptions,//产品类型
  algProduceSpaciesOptions,//产品品种
  algSatelliteTypeOptions,//卫星种类
  algSatelliteNameOptions,//卫星名称
  algSatelliteSensorOptions,//卫星载荷
  algInteractionTypeOptions,//交互类型
  algDeliveryModeOptions,//传递模式
} from '../components/publicData'
import { getPeriodicTime, removeRepeatPropertyFromArray } from '../components/publicFunctions'
import DownloadFileComponent from '../components/downFileComponent'
import PreviewFileComponent from '../components/previewFileComponent/previewFileComponent';
import Header4 from 'src/components/Header/Header4'
import refresh from '../static/refresh.png'
import submenu from '../static/submenu.png'
import more from '../static/more.png'
import download from '../static/download.png'
import detailed from '../static/detailed.png'
import nodata from '../static/nodata.png'

const { RangePicker } = DatePicker
const { Option } = Select;
const CheckboxGroup = Checkbox.Group
const getScoreRoot = global.url ? global.url.score : null;
const dateFormat = "YYYY-MM-DD"
let isShowAdvancedSearchCondition = false//是否展示高级检索
// let tempList = [] //暂时存储选中的模型算法
// let diffAlgorithmModelTypeDataMap = new Map()
class AlgorithmModelSharing extends Component {

  state = {
    userScore: 0,//当前用户的积分
    downLoadTotalScore: 0,//下载模型所需的总积分
    isDownloadModalShown: false,//是否显示下载框
    downloadList: [],//下载列表
    diffAlgorithmModelTypeScoreList: [],//不同类型模型所需分数
    diffAlgorithmModelTypeScoreAllList: [],
    algProduceType: undefined,//产品类型
    algProduceSpacies: undefined,//产品品种
    algKeyWord: '',//算法关键字
    algStartTime: '',//算法测量开始时间
    algEndTime: '',//算法测量结束时间
    algChinestName: null,//算法中文名称
    algEnglishName: null,//算法英文名称
    algLevel: null,//算法级别
    algVersion: null,//算法版本
    algAuthor: null,//算法作者
    algUploadUser: null,//算法上传用户
    algSatelliteType: undefined,//卫星种类
    algSatelliteSensor: undefined,//卫星载荷
    algSatelliteName: undefined,//卫星名称
    algInteractionType: undefined,//交互类型
    algDeliveryMode: undefined,//传递模式
    algModelType: undefined,//模型类型
    algModelTypeList: [],//通过查询浙大数据库，检索到的模型类型列表
    algorithmModelList: [],//检索到的算法模型列表
    algorithmModelTotal: 0,//检索到的算法模型总数
    algorithmModelPageNumber: 1,//当前所在页码数
    algCheckedList: [],//选中欲下载的算法模型列表
    indeterminate: false,//全选按钮的中间状态
    isCheckedTotalAlg: false,//是否全选中
    filePreviewPath: '',//文档预览路径
    currentPreviewItem: null,//当前预览项
    isPreviewModalshown: false,//预览界面是否显示
    initSuccess: false,//初始化是否成功
    initFlag: false,//是否初始化
    who: null,
  }

  componentDidMount() {
    this.init();
    this.getDiffTypeDataScore().then(
      () => {
        this.searchAlgorithmModel(1, 10)//第一次进入页面填充数据，注意先获取积分，获取到后查询页面数据
      }
    )

  }
  componentDidUpdate(preProps, preState) {
    if (this.props.zd_user && !this.state.initSuccess && !this.state.initFlag) this.init();
    if (preState.algModelType !== this.state.algModelType) this.getDiffTypeDataScore()
  }
  // componentWillUnmount() {
  //   diffAlgorithmModelTypeDataMap.clear()
  // }
  init() {
    if (!this.props.zd_user.token) return;
    this.setState({
      initFlag: true,
    })
    this.getUserScore();
    this.getAllModelTypeList();
  }

  //获取模型算法下载所需积分
  getDiffTypeDataScore = async () => {
    const { data: res } = await axios.get(getScoreRoot + '/type/list')
    // console.log('getDiffTypeDataScore---', res)
    if (res.code === '200') {
      // console.log('类型积分列表',res.payload);
      this.setState({
        diffAlgorithmModelTypeScoreAllList: res.payload
      })
    } else {
      message.error('算法模型下载积分获取失败!')
    }
  }

  setDiffTypeDataScore = (pageNumber, pageSize) => {
    let diffAlgorithmModelTypeScoreList = [];
    // console.log("是否获取到类型列表",this.state.diffAlgorithmModelTypeScoreAllList)
    this.state.diffAlgorithmModelTypeScoreAllList.forEach(element => {
      if (element.resourceType === this.state.algModelType || this.state.algModelType === undefined) {
        diffAlgorithmModelTypeScoreList.push(element)
      }
    })
    this.setState({
      diffAlgorithmModelTypeScoreList: diffAlgorithmModelTypeScoreList
    }, async () => {
      await this.getAlgorithmModel(pageNumber, pageSize)
    })
  }

  /* 获取浙大模型类型列表 */
  getAllModelTypeList = () => {
    if (!this.props.zd_user) return
    const { zd_user } = this.props;
    // this.setState({ spinning: true });
    axios.get(`/gateway/api/interface/api/getAlgorithmModelMapping`, {
      headers: {
        Authorization: zd_user.token,
      }
    }
    ).then(res => {
      // console.log("getAllModelTypeList-----", res.data,);
      console.log("getAllModelTypeList===", res)
      if (res.data.code === "0") {
        let data = res.data.data;
        this.setState({
          algModelTypeList: [...data],
          initSuccess: true,
        })
      }
      else {
        message.error(res.data.info);
      }
      // this.setState({ spinning: false });
    }).catch((e) => {
      message.error("检索失败，请检查网络连接……")
      console.log(e);
      this.setState({
        initFlag: false,
        initSuccess: false,
      })
      // this.setState({ spinning: false });
    })
  }

  getUserScore = async () => {
    if (!this.props.user.userId) return
    axios({
      url: global.url.score + '/score/getbyid',
      method: 'get',
      params: {
        userId: this.props.user.userId,
      },
      headers: {
          'Authorization': this.props.user.token
      }
    }).then(res => {
      // console.log("getUserScore", res)
      if (res.data.code === '200' && res.data.payload) {
        this.setState({ userScore: res.data.payload.score })
      } else {
        message.error('用户积分查询错误或用户积分不存在');
      }
    }).catch(err => {
      console.log(err);
      message.error('用户积分查询错误或用户积分不存在');
    })
  }

  // 重置检索条件
  resetSearchConditions = () => {
    this.setState({
      algProduceType: undefined,//产品类型
      algProduceSpacies: undefined,//产品品种
      algKeyWord: '',//算法关键字
      algStartTime: '',//算法测量开始时间
      algEndTime: '',//算法测量结束时间
      algChinestName: null,//算法中文名称
      algEnglishName: null,//算法英文名称
      algLevel: null,//算法级别
      algVersion: null,//算法版本
      algAuthor: null,//算法作者
      algUploadUser: null,//算法上传用户
      algSatelliteType: undefined,//卫星种类
      algSatelliteSensor: undefined,//卫星载荷
      algSatelliteName: undefined,//卫星名称
      algInteractionType: undefined,//交互类型
      algDeliveryMode: undefined,//传递模式
      algModelType: undefined,//模型类型
      who: null
    })
  }

  // 展示高级检索条件区域
  showAdvancedSearchCondition = () => {
    if (!isShowAdvancedSearchCondition) {
      document.getElementById('advanced-search-condition').style.height = '841px'
      // document.getElementById('algorithmModelSharing-background').style.minHeight = 'calc(802px + 4rem)'
      document.getElementById('algorithmModelSharing-advanced-search-condition').setAttribute('style', `display:block`)
      // document.getElementById('algorithmModelSharing-result-content').style.minHeight = '802px'
      // document.getElementById('algorithmModelSharing-result-content-items-wrap').style.minHeight = '710px'
      document.getElementById('advanced-icon').style.transform = 'rotate(180deg)'
      isShowAdvancedSearchCondition = !isShowAdvancedSearchCondition
    } else {
      document.getElementById('advanced-search-condition').style.height = '474px'
      // document.getElementById('algorithmModelSharing-background').style.minHeight = 'calc(435px + 4rem)'
      document.getElementById('algorithmModelSharing-advanced-search-condition').setAttribute('style', `display:none`)
      // document.getElementById('algorithmModelSharing-result-content').style.minHeight = '435px'
      // document.getElementById('algorithmModelSharing-result-content-items-wrap').style.minHeight = '333px'
      document.getElementById('advanced-icon').style.transform = 'rotate(0deg)'
      isShowAdvancedSearchCondition = !isShowAdvancedSearchCondition
    }
  }

  // select选择框的统一方法
  changeSelectFrameValue = (selectFrameName, value) => {
    // console.log(selectFrameName,value)
    switch (selectFrameName) {
      // 设置产品类型属性值
      case '产品类型':
        this.setState({
          algProduceType: value,
          algProduceSpacies: undefined
        })
        break;
      // 设置产品品种属性值
      case '产品品种':
        this.setState({
          algProduceSpacies: value
        })
        break;
      // 设置算法测量时间
      case '时间段选择':
        this.setState({
          algStartTime: value[0],
          algEndTime: value[1]
        })
        break;
      // 设置卫星种类属性值
      case '卫星种类':
        this.setState({
          algSatelliteType: value,
          algSatelliteName: undefined,
          algSatelliteSensor: undefined
        })
        break;
      // 设置卫星名称属性值
      case '卫星名称':
        this.setState({
          algSatelliteName: value,
          algSatelliteSensor: undefined
        })
        break;
      // 设置卫星载荷属性值
      case '卫星载荷':
        this.setState({
          algSatelliteSensor: value
        })
        break;
      // 设置交互类型属性值
      case '交互类型':
        this.setState({
          algInteractionType: value
        })
        break;
      // 设置传递模式属性值
      case '传递模式':
        this.setState({
          algDeliveryMode: value
        })
        break;
      // 设置模型类型属性值
      case '模型类型':
        this.setState({
          algModelType: value
        })
        break;
      case '平台/个人':
        this.setState({
          who: value
        })
        break;
      default:
        break;
    }
  }

  // input输入框的统一方法
  changeInputFrameValue = (inputFrameName, event) => {
    switch (inputFrameName) {
      case '关键字':
        this.setState({
          algKeyWord: event.target.value
        })
        break;
      case '快速选择时间':
        let startTime = getPeriodicTime(new Date().getTime(), event.target.value)
        let endTime = moment(new Date(), dateFormat)
        this.setState({
          algStartTime: startTime,
          algEndTime: endTime
        })
        break;
      case '中文名称':
        this.setState({
          algChinestName: event.target.value
        })
        break;
      case '英文名称':
        this.setState({
          algEnglishName: event.target.value
        })
        break;
      case '算法级别':
        this.setState({
          algLevel: event.target.value
        })
        break;
      case '算法版本':
        this.setState({
          algVersion: event.target.value
        })
        break;
      case '算法作者':
        this.setState({
          algAuthor: event.target.value
        })
        break;
      case '上传用户':
        this.setState({
          algUploadUser: event.target.value
        })
        break;
      default:
        break;
    }
  }

  // 获取算法模型
  getAlgorithmModel = async (pageNumber, pageSize) => {
    const { zd_user } = this.props;
    const {
      algProduceType,//产品类型
      algProduceSpacies,//产品品种
      algKeyWord,//算法关键字
      algStartTime,//算法测量开始时间
      algEndTime,//算法测量结束时间
      algChinestName,//算法中文名称
      algEnglishName,//算法英文名称
      algLevel,//算法级别
      algVersion,//算法版本
      algAuthor,//算法作者
      algUploadUser,//算法上传用户
      // algSatelliteType,//卫星种类
      algSatelliteSensor,//卫星载荷
      algSatelliteName,//卫星名称
      algInteractionType,//交互类型
      algDeliveryMode,//传递模式
      algModelType,//模型类型
      who
    } = this.state

    let searchParams = {
      // modelname: algModelType,
      producetype: algProduceType,
      producename: algProduceSpacies,
      keyword: algKeyWord,
      starttime: algStartTime === '' ? -1 : algStartTime,
      endtime: algEndTime === '' ? -1 : algEndTime,
      chsname: algChinestName,
      algorithmname: algEnglishName,
      algorithmlevel: algLevel ? algLevel.split(/,|，/) : null,//多个分割符，主要是考虑了中英文的逗号
      version: algVersion,
      author: algAuthor,
      uploaduser: algUploadUser,
      satellite: algSatelliteName,
      sensor: algSatelliteSensor,
      artificial: algInteractionType,
      datatransmodel: algDeliveryMode,
      page: pageNumber,//分页页码
      num: pageSize,//每页10条数据
    }
    if (who) {
      searchParams.who = who
    }
    this.setState({
      algorithmModelList: []
    })
    // console.log(searchParams)
    let url = '/gateway/api/interface/api/getAlgorithmData'
    if (algModelType !== null && algModelType !== undefined) {
      url += `?modelname=${algModelType}`
    }
    let param = searchParams
    for (let key in searchParams) {
      if (searchParams[key] === null || searchParams[key] === undefined) {
        delete param[key]
      }
    }
    await axios.post(url, param, {
      headers: {
        Authorization: zd_user.token,
      }
    }).then(res => {
      if (res.data.code === '0') {
        let data = res.data.data
        let list = data.list

        list.map(item => {
          let obj = this.state.diffAlgorithmModelTypeScoreList.filter(child => child.resourceType === item.modelname)
          if (obj.length) {
            item.score = obj[0].downloadScore
          } else {
            item.score = 0
          }
          return item
        })
        console.log('添加积分后类型列表', list);
        this.setState({
          algorithmModelList: list,
          algorithmModelTotal: data.total,
          algorithmModelPageNumber: pageNumber
        })
      } else {
        message.error('数据获取失败，请重试')
      }
    })
    // console.log(res)

    // this.setState({
    //   algorithmModelList: res.data.list,
    //   algorithmModelTotal: res.data.total,
    //   algorithmModelPageNumber: pageNumber
    // })
  }

  // 分页查询算法模型
  searchAlgorithmModel = (pageNumber, pageSize) => {
    const { algModelType, } = this.state//模型类型
    this.setDiffTypeDataScore(pageNumber, pageSize)
  }
  // 改变页码
  changePaginationNumber = (pageNumber) => {
    // console.log(pageNumber)
    this.searchAlgorithmModel(pageNumber, 10)
    this.setState({
      isCheckedTotalAlg: false,
      indeterminate: false
    })
  }

  // 选中算法模型item项
  changeCheckList = (checkList) => {
    // console.log(checkList)
    // tempList = [...tempList, ...checkList]
    // tempList = removeRepeatPropertyFromArray(tempList)
    // console.log(tempList)
    this.setState({
      algCheckedList: checkList,
      indeterminate: checkList.length && checkList.length < this.state.algorithmModelList.length,
      isCheckedTotalAlg: checkList.length === this.state.algorithmModelList.length
    })
  }

  // 全选和取消全选
  checkedTotalAlgorithm = async (event) => {
    // this.searchAlgorithmModel(1,this.state.algorithmModelTotal)
    // let allAlgData = []
    // if (!diffAlgorithmModelTypeDataMap.has(this.state.algModelType)) {
    //   allAlgData = await this.getAlgorithmModel(1, this.state.algorithmModelTotal)
    //   console.log(allAlgData)
    // } else {
    //   allAlgData = diffAlgorithmModelTypeDataMap.get(this.state.algModelType)
    // }
    this.setState({
      algCheckedList: event.target.checked ? this.state.algorithmModelList : [],
      indeterminate: false,
      isCheckedTotalAlg: event.target.checked
    })
  }

  // 当个算法模型下载
  downloadSingleAlgorithm = (downItem) => {
    // console.log("downItem", downItem)
    // downItem.score = this.state.diffAlgorithmModelTypeScore
    this.setState({
      downloadList: [downItem],
      downLoadTotalScore: downItem.score,
      isDownloadModalShown: true
    })
  }

  // 批量下载算法模型
  downloadMultipleAlgorithm = () => {
    let tempList = this.state.algCheckedList
    let totalScore = 0
    tempList.map(item => {
      totalScore += item.score
    })
    this.setState({
      downloadList: tempList,
      downLoadTotalScore: totalScore,
      isDownloadModalShown: true
    })
  }
  closeDownLoadModal = () => {
    this.setState({
      isDownloadModalShown: false,
    })
  }

  clearAlgCheckedList = () => {
    this.setState({
      algCheckedList: [],
      indeterminate: false,
      isCheckedTotalAlg: false
    })
  }

  documemtPreview = async (previewItem) => {
    let dataName = previewItem.algorithmname + '.zip'
    const { data: res } = await axios.get(`/gateway/api/interface/api/getAlgorithmDocumentPath?dataNames=${dataName}`, {
      headers: {
        Authorization: this.props.zd_user.token
      }
    })
    console.log('详情检查：', Object.values(res.data)[0])
    if (res.code === '0') {
      this.setState({
        filePreviewPath: Object.values(res.data)[0].replace("http://10.0.121.14:8084", "https://caplos.aircas.ac.cn/zdTiles"),
        isPreviewModalshown: true,
        currentPreviewItem: previewItem
      })
    } else {
      message.error('文档预览失败！')
    }
  }

  render() {
    return (
      <div>
        <Header4></Header4>
        {/* 界面背景 */}
        <div className="algorithmModelSharing-background" id="algorithmModelSharing-background">
          {/* 检索及结果界面 */}
          <div className="algorithmModelSharing-content">
            {/* 界面左侧检索区域 */}
            <div className="algorithmModelSharing-search-content" id="advanced-search-condition">
              {/* 检索区域标题行 */}
              <div className="algorithmModelSharing-search-title">
                <div className="algorithmModelSharing-search-text">算法模型检索</div>
                <div className="algorithmModelSharing-search-reset">
                  <img src={refresh} className="algorithmModelSharing-search-reset-img"></img>
                  <div className="algorithmModelSharing-search-rest-text" onClick={() => this.resetSearchConditions()}>重置条件</div>
                </div>
              </div>
              {/* 模型类型 */}
              <div className="algorithmModelSharing-search-modelType">
                <Select
                  allowClear
                  className="algorithmModelSharing-search-modelType-select"
                  placeholder="模型类型"
                  value={this.state.algModelType}
                  onChange={(e) => { this.changeSelectFrameValue('模型类型', e) }}
                >
                  {
                    this.state.algModelTypeList.map((algMmodalType, index) => {
                      let modelname = algMmodalType.modelname;
                      return <Option value={modelname} key={`${modelname}-${index}`}>{modelname}</Option>
                    })
                  }
                </Select>
              </div>
              {/* 产品类型 */}
              <div className="algorithmModelSharing-search-produceType">
                <Select
                  allowClear
                  className="algorithmModelSharing-search-produceType-select"
                  placeholder="产品类型"
                  onChange={(e) => { this.changeSelectFrameValue('产品类型', e) }}
                  value={this.state.algProduceType}
                  options={algProduceCategoryOptions}
                ></Select>
              </div>
              {/* 产品品种 */}
              <div className="algorithmModelSharing-search-produceSpacies">
                <Select
                  allowClear
                  className="algorithmModelSharing-search-produceSpacies-select"
                  placeholder="产品品种"
                  onChange={(e) => { this.changeSelectFrameValue('产品品种', e) }}
                  value={this.state.algProduceSpacies}
                  options={algProduceSpaciesOptions[this.state.algProduceType] ? algProduceSpaciesOptions[this.state.algProduceType] : null}
                ></Select>
              </div>
              {/* 检索区域模型关键字行 */}
              <div className="algorithmModelSharing-search-keyword">
                <Input className="algorithmModelSharing-search-keyword-input" placeholder="关键字" onChange={(e) => this.changeInputFrameValue('关键字', e)}></Input>
              </div>
              {/* 检索区域模型测量时间行 */}
              <div className="algorithmModelSharing-search-time">
                <RangePicker
                  className="algorithmModelSharing-search-timepicker"
                  placeholder={['测量开始时间', '测量结束时间']}
                  format={dateFormat}
                  value={moment(this.state.algStartTime, dateFormat)._isValid ? [moment(this.state.algStartTime, dateFormat), moment(this.state.algEndTime, dateFormat)] : ['', '']}
                  onChange={(_, e) => { this.changeSelectFrameValue('时间段选择', e) }}
                ></RangePicker>
              </div>
              <div className='algorithmModelSharing-search-default-other'>
                <Select
                  allowClear
                  className="algorithmModelSharing-search-produceType-select"
                  placeholder="平台/个人"
                  onChange={(e) => { this.changeSelectFrameValue('平台/个人', e) }}
                  value={this.state.who}
                  options={[{
                    value: 'admin',
                    label: '平台',
                  },
                  {
                    value: 'person',
                    label: '个人',
                  }]}
                ></Select>
              </div>
              {/* 检索区域模型测量预设时间行 */}
              <div className="algorithmModelSharing-search-default-time">
                <Radio.Group className="algorithmModelSharing-search-today" onChange={(e) => { this.changeInputFrameValue('快速选择时间', e) }}>
                  <Radio value={'day'} className="algorithmModelSharing-search-today-radio">
                    <div title="一天内" className="algorithmModelSharing-search-today-radio-text">一天内</div>
                  </Radio>
                  <Radio value={'week'} className="algorithmModelSharing-search-today-radio">
                    <div title="一周内" className="algorithmModelSharing-search-today-radio-text">一周内</div>
                  </Radio>
                  <Radio value={'month'} className="algorithmModelSharing-search-today-radio">
                    <div title="一月内" className="algorithmModelSharing-search-today-radio-text">一月内</div>
                  </Radio>
                  <Radio value={'year'} className="algorithmModelSharing-search-today-radio">
                    <div title="一年内" className="algorithmModelSharing-search-today-radio-text">一年内</div>
                  </Radio>
                </Radio.Group>
              </div>
              {/* 高级检索标题栏 */}
              <div className="algorithmModelSharing-advanced-search-title">
                <div className="algorithmModelSharing-advanced-search-area">
                  <div className="algorithmModelSharing-advanced-search-img-wrap">
                    <img src={submenu} className="algorithmModelSharing-advanced-search-img"></img>
                  </div>
                  <div className="algorithmModelSharing-advanced-search-text"> 高级检索</div>
                </div>
                <img src={more} id="advanced-icon" className="algorithmModelSharing-advanced-search-more" onClick={() => this.showAdvancedSearchCondition()}></img>
              </div>
              {/* 高级检索条件区域 */}
              <div className="algorithmModelSharing-advanced-search-condition" id="algorithmModelSharing-advanced-search-condition" style={{ display: 'none' }}>
                <div className="algorithmModelSharing-advanced-search-chineseName-wrap">
                  {/* 中文名称 */}
                  <Input className="algorithmModelSharing-advanced-search-chineseName" placeholder="中文名称" onChange={(e) => this.changeInputFrameValue('中文名称', e)}></Input>
                </div>
                <div className="algorithmModelSharing-advanced-search-englishName-wrap">
                  {/* 英文名称 */}
                  <Input className="algorithmModelSharing-advanced-search-englishName" placeholder="英文名称" onChange={(e) => this.changeInputFrameValue('英文名称', e)}></Input>
                </div>
                <div className="algorithmModelSharing-advanced-search-algLevel-algVersion-wrap">
                  {/* 算法级别 */}
                  <Input title="可多填,','分割" className="algorithmModelSharing-advanced-search-algLevel" placeholder="算法级别,可多填,','分割" onChange={(e) => this.changeInputFrameValue('算法级别', e)}></Input>
                  {/* 算法版本 */}
                  <Input className="algorithmModelSharing-advanced-search-algVersion" placeholder="算法版本" onChange={(e) => this.changeInputFrameValue('算法版本', e)}></Input>
                </div>
                <div className="algorithmModelSharing-advanced-search-algAuthor-uploadUser-wrap">
                  {/* 算法作者 */}
                  <Input className="algorithmModelSharing-advanced-search-algAuthor" placeholder="算法作者" onChange={(e) => this.changeInputFrameValue('算法作者', e)}></Input>
                  {/* 上传用户 */}
                  <Input className="algorithmModelSharing-advanced-search-uploadUser" placeholder="上传用户" onChange={(e) => this.changeInputFrameValue('上传用户', e)}></Input>
                </div>
                <div className="algorithmModelSharing-advanced-search-satellite-type-sensor-wrap">
                  {/* 卫星种类 */}
                  <div className="algorithmModelSharing-advanced-search-satelliteType-wrap">
                    <div className="algorithmModelSharing-advanced-search-satelliteType-title">卫星种类</div>
                    <Select
                      allowClear
                      className="algorithmModelSharing-advanced-search-satelliteType-select"
                      placeholder="全部"
                      options={algSatelliteTypeOptions}
                      onChange={(e) => this.changeSelectFrameValue('卫星种类', e)}
                      value={this.state.algSatelliteType}
                    ></Select>
                  </div>
                  {/* 卫星名称 */}
                  <div className="algorithmModelSharing-advanced-search-satelliteName-wrap">
                    <div className="algorithmModelSharing-advanced-search-satelliteName-title">卫星名称</div>
                    <Select
                      allowClear
                      className="algorithmModelSharing-advanced-search-satelliteName-select"
                      placeholder="全部"
                      options={algSatelliteNameOptions[this.state.algSatelliteType] ? algSatelliteNameOptions[this.state.algSatelliteType] : null}
                      onChange={(e) => this.changeSelectFrameValue('卫星名称', e)}
                      value={this.state.algSatelliteName}
                    ></Select>
                  </div>
                </div>
                <div className="algorithmModelSharing-advanced-search-satellite-name-type-wrap">
                  {/* 卫星载荷 */}
                  <div className="algorithmModelSharing-advanced-search-satelliteSensor-wrap">
                    <div className="algorithmModelSharing-advanced-search-satelliteSensor-title">卫星载荷</div>
                    <Select
                      allowClear
                      className="algorithmModelSharing-advanced-search-satelliteSensor-select"
                      placeholder="全部"
                      options={algSatelliteSensorOptions[this.state.algSatelliteName] ? algSatelliteSensorOptions[this.state.algSatelliteName] : null}
                      onChange={(e) => this.changeSelectFrameValue('卫星载荷', e)}
                      value={this.state.algSatelliteSensor}
                    ></Select>
                  </div>
                  {/* 交互类型 */}
                  <div className="algorithmModelSharing-advanced-search-interactionType-wrap">
                    <div className="algorithmModelSharing-advanced-search-interactionType-title">交互类型</div>
                    <Select
                      allowClear
                      className="algorithmModelSharing-advanced-search-interactionType-select"
                      placeholder="全部"
                      options={algInteractionTypeOptions}
                      value={this.state.algInteractionType}
                      onChange={(e) => { this.changeSelectFrameValue('交互类型', e) }}
                    ></Select>
                  </div>
                </div>
                <div className="algorithmModelSharing-advanced-search-mode-Type-wrap">
                  {/* 传递模式 */}
                  <div className="algorithmModelSharing-advanced-search-deliveryMode-wrap">
                    <div className="algorithmModelSharing-advanced-search-deliveryMode-title">传递模式</div>
                    <Select
                      allowClear
                      className="algorithmModelSharing-advanced-search-deliveryMode-select"
                      placeholder="全部"
                      options={algDeliveryModeOptions}
                      value={this.state.algDeliveryMode}
                      onChange={(e) => { this.changeSelectFrameValue('传递模式', e) }}
                    ></Select>
                  </div>
                </div>
              </div>
              {/* 检索按钮区域 */}
              <div className="algorithmModelSharing-search-buttom-wrap">
                <div className="algorithmModelSharing-search-buttom" onClick={() => this.searchAlgorithmModel(1, 10)}>
                  检索
                </div>
              </div>
            </div>
            {/* 界面右侧结果区域 */}
            <div className="algorithmModelSharing-result-content" id="algorithmModelSharing-result-content">
              {/* 检索结果区域头部标题栏 */}
              <div className="algorithmModelSharing-result-content-title-wrap">
                <div className="algorithmModelSharing-result-content-title">算法模型列表</div>
                <div className="algorithmModelSharing-result-content-download-buttom">
                  <img src={download} className="algorithmModelSharing-result-content-download-buttom-img"></img>
                  <div className="algorithmModelSharing-result-content-download-buttom-text" onClick={() => { this.downloadMultipleAlgorithm() }}>批量提交下载订单</div>
                </div>
              </div>
              {/* 全选按钮区 */}
              <div className="algorithmModelSharing-result-content-checkall-wrap">
                <Checkbox
                  className="algorithmModelSharing-result-content-checkall-buttom"
                  indeterminate={this.state.indeterminate}
                  checked={this.state.isCheckedTotalAlg}
                  disabled={this.state.algorithmModelList.length === 0 ? true : false}
                  onChange={(e) => { this.checkedTotalAlgorithm(e) }}
                >全选</Checkbox>
                <div className="algorithmModelSharing-result-content-checkall-result">已勾选{this.state.algCheckedList.length}个算法</div>
              </div>
              {/* 检索结果区 */}
              <div className="algorithmModelSharing-result-content-items-wrap" id="algorithmModelSharing-result-content-items-wrap">
                {
                  this.state.algorithmModelList.length === 0 ?
                    <>
                      {/* 无检索结果 */}
                      <div className="algorithmModelSharing-result-content-nodata-wrap">
                        <img src={nodata} className="algorithmModelSharing-result-content-nodata-img"></img>
                      </div>
                    </> :
                    <>
                      {/* 检索结果列表 */}
                      <CheckboxGroup
                        className="algorithmModelSharing-result-content-item-checkbox-group"
                        value={this.state.algCheckedList}
                        onChange={(value) => { this.changeCheckList(value) }}
                      >
                        {
                          this.state.algorithmModelList.map((item, index) => {
                            return <div key={item.id} className="algorithmModelSharing-result-content-item-checkbox-wrap">
                              <Checkbox value={item} className="algorithmModelSharing-result-content-item-checkbox" ></Checkbox>
                              <div className={this.state.algCheckedList.indexOf(item) === -1 ? "algorithmModelSharing-result-content-item-wrap" : "algorithmModelSharing-result-content-item-wrap-checked"}>
                                {/* 检索结果项上部分内容 */}
                                <div className="algorithmModelSharing-result-content-item-top-area">
                                  {/* 检索结果项上部分左侧属性信息 */}
                                  <div className="algorithmModelSharing-result-content-item-topleft-area">
                                    {/* 中文名称/算法名称 */}
                                    <div className="algorithmModelSharing-result-content-item-topleft-chanesename">{item.algorithmname}</div>
                                    <div className="algorithmModelSharing-result-content-item-topleft-other-attributes">
                                      {/* 算法英文名 */}
                                      <div title={item.chsname} className="algorithmModelSharing-result-content-item-topleft-other-attributes-englishname">{item.chsname}</div>
                                      {/* 产品种类 */}
                                      <div className="algorithmModelSharing-result-content-item-topleft-other-attributes-produceType">{item.producetype}</div>
                                      {/* 算法级别*/}
                                      <div className="algorithmModelSharing-result-content-item-topleft-other-attributes-algLevel">LEVEL{item.algorithmlevel}</div>
                                      {/* 算法版本 */}
                                      <div className="algorithmModelSharing-result-content-item-topleft-other-attributes-algVersion">Version{item.version}</div>
                                    </div>
                                  </div>
                                  {/* 检索结果项上部分右侧属性信息 */}
                                  <div className="algorithmModelSharing-result-content-item-topright-area">
                                    <div className="algorithmModelSharing-result-content-item-topright-detailed-buttom">
                                      <img src={detailed} className="algorithmModelSharing-result-content-item-topright-detailed-buttom-img"></img>
                                      <div className="algorithmModelSharing-result-content-item-topright-detailed-buttom-text" onClick={() => this.documemtPreview(item)}>详情</div>
                                    </div>
                                    <div className="algorithmModelSharing-result-content-item-topright-download-buttom">
                                      <img src={download} className="algorithmModelSharing-result-content-item-topright-download-buttom-img"></img>
                                      <div className="algorithmModelSharing-result-content-item-topright-download-buttom-text" onClick={() => { this.downloadSingleAlgorithm(item) }}>提交下载订单</div>
                                    </div>
                                  </div>
                                </div>
                                {/* 检索结果项下部分内容 */}
                                <div className="algorithmModelSharing-result-content-item-bootom-area">
                                  {/* 检索结果项下部分左侧属性信息 */}
                                  <div className="algorithmModelSharing-result-content-item-bootomleft-area">
                                    {/* 交互类型 */}
                                    <div className="algorithmModelSharing-result-content-item-bootomleft-interactionType">
                                      <div className="algorithmModelSharing-result-content-item-bootomleft-interactionType-attr-name">交互类型</div>
                                      <div className="algorithmModelSharing-result-content-item-bootomleft-interactionType-attr-value">{item.artificial}</div>
                                    </div>
                                    {/* 卫星 */}
                                    <div className="algorithmModelSharing-result-content-item-bootomleft-satelliteName">
                                      <div className="algorithmModelSharing-result-content-item-bootomleft-satelliteName-attr-name">卫星</div>
                                      <div className="algorithmModelSharing-result-content-item-bootomleft-satelliteName-attr-value">{item.satellite}</div>
                                    </div>
                                    {/* 传感器 */}
                                    <div className="algorithmModelSharing-result-content-item-bootomleft-satelliteSensor">
                                      <div className="algorithmModelSharing-result-content-item-bootomleft-satelliteSensor-attr-name">传感器</div>
                                      <div className="algorithmModelSharing-result-content-item-bootomleft-satelliteSensor-attr-value">{item.sensor}</div>
                                      {/* <div className="algorithmModelSharing-result-content-item-bootomleft-satelliteSensor-attr-value">MSS</div> */}
                                    </div>
                                  </div>
                                  {/* 检索结果项下部分右侧属性信息 */}
                                  <div className="algorithmModelSharing-result-content-item-bootomright-area">
                                    {/* 算法作者 */}
                                    <div className="algorithmModelSharing-result-content-item-bootomright-algAuthor">
                                      <div className="algorithmModelSharing-result-content-item-bootomright-algAuthor-attr-name">作者</div>
                                      <div title={item.author} className="algorithmModelSharing-result-content-item-bootomright-algAuthor-attr-value">{item.author}</div>
                                    </div>
                                    {/* 积分 */}
                                    <div className="algorithmModelSharing-result-content-item-bootomright-price">
                                      <div className="algorithmModelSharing-result-content-item-bootomright-price-attr-name">积分</div>
                                      <div className="algorithmModelSharing-result-content-item-bootomright-price-attr-value">{item.score}</div>
                                    </div>
                                    {/* 评分 */}
                                    {/* <div className="algorithmModelSharing-result-content-item-bootomright-score">
                                      <div className="algorithmModelSharing-result-content-item-bootomright-score-attr-name">评分</div>
                                      <div className="algorithmModelSharing-result-content-item-bootomright-score-attr-value">9.0</div>
                                    </div> */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          })
                        }
                        {/* 页脚区域 */}
                        <div className="algorithmModelSharing-result-pagination-wrap-out">
                          <div className="algorithmModelSharing-result-pagination-wrap-ininer">
                            <div className="algorithmModelSharing-result-pagination-totalNum">共{this.state.algorithmModelTotal}条数据</div>
                            <Pagination
                              showQuickJumper
                              showSizeChanger={false}
                              total={this.state.algorithmModelTotal}
                              current={this.state.algorithmModelPageNumber}
                              onChange={(value) => { this.changePaginationNumber(value) }}
                              defaultPageSize={10}
                              className="algorithmModelSharing-result-pagination"
                            ></Pagination>
                          </div>
                        </div>
                      </CheckboxGroup>
                    </>
                }
              </div>
            </div>
          </div>
        </div>
        <PreviewFileComponent
          isPreviewModalshown={this.state.isPreviewModalshown}
          filePreviewPath={this.state.filePreviewPath}
          // filePreviewPath =''
          currentPreviewItem={this.state.currentPreviewItem}
          colosePreviewModal={() => this.setState({ isPreviewModalshown: false })}
        ></PreviewFileComponent>
        <DownloadFileComponent
          orderList={this.state.downloadList}
          userScore={this.state.userScore}
          totalScore={this.state.downLoadTotalScore}
          resourceType={this.state.algModelType}
          showDownLoadModalFlag={this.state.isDownloadModalShown}
          closeDownLoadModal={() => this.closeDownLoadModal()}
          clearAlgCheckedList={() => this.clearAlgCheckedList()}
        ></DownloadFileComponent>
      </div>
    )
  }
}

const mapState = (state) => ({ //返回值  对应的是  组件的props  
  user: state.userReducer.get('user').toJS(),
  zd_user: state.userReducer.get('zd_user').toJS(),
})

export default connect(mapState)(AlgorithmModelSharing)